import { Favicon,Button, type ButtonProps } from "@fhs/ui";
import { Link } from '@fhs/link';

export type HeaderLogoProps = Omit<ButtonProps, 'children'>;

export function HeaderLogo(props: HeaderLogoProps) {
  return <Link href="/"><Button type="ghost" size="xl" aria-label="Go home" {...props}><Favicon size={40}  /></Button></Link>;
}
